import styled from 'styled-components';

export const InfoTitle = styled.h6`
  width:100%;
  margin: 12px 0 0;
  font-size: 13px;
  letter-spacing: 2px;
  color: rgba(0, 0, 0, 0.84);
  text-transform: uppercase;
  font-weight: 600;
  line-height: 1.2;
`;



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/styles.js